import clsx from 'clsx';
import { useAnyPlayerActive } from '@/hooks/media/useAnyPlayerActive';
import type { ReactNode } from 'react';
interface MainLayoutProps {
  children: ReactNode;
}
export const MainLayout = ({
  children
}: MainLayoutProps) => {
  const anyPlayerActive = useAnyPlayerActive();
  return <div className={clsx('main-layout relative', anyPlayerActive && 'footer-player-active')} data-sentry-component="MainLayout" data-sentry-source-file="MainLayout.tsx">
      {children}
    </div>;
};